(function () {
  // Product descriptions are pasted from all kinds of sources (Word docs,
  // plain text) and don't consistently use real <h3> headings — most just
  // have "【見出し】" inline at the start of a line. This finds that bracket
  // pattern and turns it into a visually distinct heading, regardless of
  // the underlying markup, so every product benefits without rewriting
  // each one's content by hand.

  // Some pasted content also mistakenly leaves the body text INSIDE the
  // <h3> (the closing tag ended up after the body instead of right after
  // the heading label). Split those apart first: only the text up to the
  // first <br> stays in the <h3>; everything after it moves into a new <p>
  // right after it. This fixes the common copy-paste mistake without
  // needing to hand-edit every product's description.
  //
  // The body text isn't always a direct child of the <h3> — Word/Docs paste
  // often wraps it in a <span> (or several) first. A Range spanning from
  // right after the <br> to the end of the <h3> handles that regardless of
  // nesting: extractContents() splits any in-between wrapper elements for
  // us, keeping the label's formatting intact and moving everything after
  // it — including later sibling elements — out as one fragment.
  function splitOverstuffedHeadings(root) {
    var headings = root.querySelectorAll('h3');
    headings.forEach(function (h3) {
      var br = h3.querySelector('br');
      if (!br) return;

      try {
        var range = document.createRange();
        range.setStartAfter(br);
        range.setEnd(h3, h3.childNodes.length);
        var afterFragment = range.extractContents();
        br.remove();

        // Drop leading blank lines left over from the split (e.g. a
        // "<br><br>" run) so the new paragraph doesn't start with dead space.
        while (
          afterFragment.firstChild &&
          (afterFragment.firstChild.nodeName === 'BR' ||
            (afterFragment.firstChild.nodeType === 3 && afterFragment.firstChild.textContent.trim() === ''))
        ) {
          afterFragment.removeChild(afterFragment.firstChild);
        }

        // A trailing <br> with only whitespace after it (e.g. "<h3>見出し<br>\n</h3>",
        // common when the heading itself just wraps two lines) isn't the
        // overstuffed-body pattern — there's nothing left to move once the
        // blank lines are dropped, so just leave the heading as-is.
        var hasMeaningfulContent = Array.prototype.some.call(afterFragment.childNodes, function (n) {
          return n.nodeType === 1 || (n.nodeType === 3 && n.textContent.trim() !== '');
        });
        if (!hasMeaningfulContent) return;

        var p = document.createElement('p');
        p.appendChild(afterFragment);
        h3.parentNode.insertBefore(p, h3.nextSibling);
      } catch (e) {
        // Malformed markup we can't safely split — leave the heading as-is
        // rather than risk corrupting the page.
      }
    });
  }

  // A source <h3> that's empty (or a leftover shell after the split above —
  // e.g. its only content was whitespace before a <br> whose real label came
  // after it) still gets the heading box styling and shows up as a blank
  // colored bar. Drop those rather than leave an empty box on the page.
  function removeEmptyHeadings(root) {
    root.querySelectorAll('h3').forEach(function (h3) {
      if (!h3.textContent.trim()) h3.remove();
    });
  }

  // Wrap "【見出し】"-style text in a styled span, but only where it isn't
  // already inside a real <h3> — a plain string replace on the whole
  // innerHTML would also match text that's already a heading (every real
  // <h3> here is itself a "【...】" label) and wrap it a second time,
  // producing a heading box nested inside another heading box.
  function wrapBracketHeadings(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return node.parentNode && node.parentNode.closest('h3')
          ? NodeFilter.FILTER_REJECT
          : NodeFilter.FILTER_ACCEPT;
      },
    });
    var targets = [];
    var node;
    while ((node = walker.nextNode())) {
      if (/【[^】]{1,40}】/.test(node.nodeValue)) targets.push(node);
    }
    targets.forEach(function (textNode) {
      var span = document.createElement('span');
      span.innerHTML = textNode.nodeValue.replace(/(【[^】]{1,40}】)/g, '<strong class="desc-heading">$1</strong>');
      textNode.parentNode.replaceChild(span, textNode);
      // Unwrap the temporary <span> so it doesn't add an extra layer.
      while (span.firstChild) span.parentNode.insertBefore(span.firstChild, span);
      span.remove();
    });
  }

  function format() {
    var el = document.querySelector('.product__description');
    if (!el || el.dataset.descFormatted) return;

    splitOverstuffedHeadings(el);
    wrapBracketHeadings(el);
    removeEmptyHeadings(el);
    el.dataset.descFormatted = 'true';
  }

  document.addEventListener('DOMContentLoaded', format);
  window.addEventListener('load', format);
})();
